import * as types from './types';
import { loading } from 'State/actions';

export const getVendorSetup = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VENDORSETUP_GRID_LOADING, true));
    try {
      const vendorResponse = await MPWWebApi.getGeneric(
        'InvVendors/GetAllVendors'
      );
      dispatch({
        type: types.VENDORSETUP_GET,
        payload: vendorResponse,
      });
    } catch (err) {
      dispatch({
        type: types.VENDORSETUP_GET_ERROR,
        payload: err,
      });
    }
    dispatch(loading(types.VENDORSETUP_GRID_LOADING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/page/actions.js